import React from 'react';

import { useTranslation } from 'react-i18next';
import { useRouteChangeHandler } from 'shared/hooks';

type ViewJourneyButtonProps = {
  orderId: number;
};

/**
 * 알림에서 Journey로 보내는 버튼 — 월세 납부일, 방리스트 도착, 방구해줘 본계약 1일 전.
 * 잔금·월세·공과금 체크와 임대인 계좌, 받은 방과 리스트 링크가 모두 Journey에 모여 있어,
 * 알림을 받은 직후 바로 처리할 수 있게 한다.
 * 여정이 여러 개인 회원은 알림이 가리키는 방이 아닌 다른 방이 먼저 열리므로 주문 건을 지정한다.
 */
export function ViewJourneyButton({ orderId }: ViewJourneyButtonProps) {
  const { t } = useTranslation('review');
  const { handleRouteChange } = useRouteChangeHandler();

  return (
    <div className="flex items-center gap-[10px]">
      <button
        type="button"
        onClick={() => handleRouteChange(`/journey?orderId=${orderId}`)}
        className="h-[30px] rounded-[8px] bg-[#222222] px-[12px] text-[13px] font-medium leading-[1.5] tracking-[-0.022em] text-white"
      >
        {t('myPage.viewJourney', 'View my Journey')}
      </button>
    </div>
  );
}
